import React from 'react';

import { defineMessage, useIntl } from 'react-intl';

import { NavPlatformSideNav } from '@townsquare/nav-platform-integration/NavPlatformSideNav';

import { useSideNavAppItemsForNavPlatform } from '../sidebar/use-side-nav-app-items-for-nav-platform';
import { useSideNavItems } from '../sidebar/use-side-nav-items';

import { FinesseFeedbackSpotlight } from './FinesseFeedbackSpotlight';
import { useForYouConfig } from './use-for-you-config';

const homeAppLabelMessage = defineMessage({
	id: 'townsquare.home.app.label',
	defaultMessage: 'Home',
	description: 'Label for the app when shown in the global side navigation.',
});

type Props = {
	/**
	 * Prop to disable customization of the Home sidebar, for testing purposes.
	 */
	customizationDisabled?: boolean;
};

export function HomeSideNav({ customizationDisabled }: Props): React.JSX.Element {
	const appShortcuts = useSideNavAppItemsForNavPlatform();
	const { formatMessage } = useIntl();

	const forYouConfig = useForYouConfig({ ItemWrapper: FinesseFeedbackSpotlight });
	const sidebarItems = useSideNavItems();

	return (
		<NavPlatformSideNav
			app="home"
			appLabel={formatMessage(homeAppLabelMessage)}
			appItems={sidebarItems}
			appShortcuts={appShortcuts}
			disableMenuCustomization={customizationDisabled}
			customizationStore={customizationDisabled ? 'local' : 'network-migration'}
			forYou={forYouConfig}
		/>
	);
}
